import { usersOrganisationsRolesQueryOptions } from "@/features/auth/api/selectUsersOrganisationsRoles";
import { getOnboardedAppHome } from "@/features/auth/utils/getAuthenticatedPublicLanding";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { UsersNavTabs } from "@/features/admin/components/UsersNavTabs";
import { useNav } from "@/utils/nav";
import { Button } from "@patient-watch/ui/button";
import { Link, Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { UserPlus } from "lucide-react";

export const Route = createFileRoute("/_app/users")({
    component: UsersLayout,
    beforeLoad: async ({ context }) => {
        const userId = context?.auth?.id;
        if (!userId || !context?.queryClient) {
            throw redirect({ to: "/login" });
        }

        const roles = await context.queryClient.ensureQueryData(usersOrganisationsRolesQueryOptions(userId));
        context.auth.roles.setRoles(roles ?? []);

        if (!context.auth.roles.isAdmin) {
            throw redirect({ to: getOnboardedAppHome(context.auth.roles) });
        }

        return context;
    },
});

function UsersLayout() {
    useNav([{ label: "Users", route: { to: "/users" } }]);

    return (
        <AdminPageLayout
            title="Users"
            description="Browse users by role. Update organisations and billing from the table."
            headerActions={
                <Button asChild size="sm">
                    <Link to="/users/create-user/details">
                        <UserPlus className="mr-1.5 w-3.5 h-3.5" />
                        Create user
                    </Link>
                </Button>
            }
        >
            <div className="space-y-6">
                <UsersNavTabs />
                <Outlet />
            </div>
        </AdminPageLayout>
    );
}
